import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { getValueFromStringObjPath } from "@default/paragraphs/webform/webform-elements";

const HiddenField = ({ item, compositeIndex, compositeParent }) => {
  const { values, handleChange, handleBlur } = useFormikContext();

  const value = compositeParent
    ? typeof compositeIndex !== "undefined"
      ? getValueFromStringObjPath(values, compositeParent)?.[compositeIndex]?.[
          item.id
        ]
      : getValueFromStringObjPath(values, compositeParent)[item.id]
    : values[item.id];
  const identifier = compositeParent
    ? typeof compositeIndex !== "undefined"
      ? `${compositeParent}[${compositeIndex}][${item.id}]`
      : `${compositeParent}[${item.id}]`
    : item.id;

  return (
    <div className="form-group">
      <input
        id={identifier}
        name={identifier}
        type="hidden"
        onChange={handleChange}
        onBlur={handleBlur}
        value={value}
      />
    </div>
  );
};

HiddenField.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
  }),
  compositeIndex: PropTypes.number,
  compositeParent: PropTypes.string,
};

export default HiddenField;
